<template>
  <div class="policy-page">
    <HomeButton />
    <div class="policy-page__container">
      <p v-if="policyStore.isLoading" class="policy-page__state">
        Загружаем политику...
      </p>

      <p v-else-if="policyStore.error" class="policy-page__state policy-page__state--error">
        {{ policyStore.error }}
      </p>

      <div
        v-else-if="policyStore.policyHtml"
        class="policy-page__content"
        v-html="policyStore.policyHtml"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { usePolicyStore } from '@/entities/Policy/model/policyStore'
import HomeButton from '@/ui/components/HomeButton.vue'

const policyStore = usePolicyStore()

onMounted(async () => {
  await policyStore.fetchPolicy()
})
</script>

<style scoped lang="scss">
.policy-page {
  height: 100%;
  overflow-y: auto;
}

.policy-page__container {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 8px 60px;
}

.policy-page__state {
  @include p2-regular;
  opacity: 0.8;
}

.policy-page__state--error {
  color: $secondary-100;
}

.policy-page__content {
  @include p2-regular;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.policy-page__content :deep(h1),
.policy-page__content :deep(h2) {
  margin: 16px 0 8px;
}

.policy-page__content :deep(p),
.policy-page__content :deep(li),
.policy-page__content :deep(a),
.policy-page__content :deep(span) {
  color: $neutral-100;
}

.policy-page__content :deep(ul) {
  padding-left: 20px;
  margin: 8px 0;
}

.policy-page__content :deep(.privacy-text-primary) {
  color: $primary-100;
}

.policy-page__content :deep(.privacy-text-secondary) {
  color: $neutral-60;
}

.policy-page__content :deep(.privacy-text-default) {
  color: $neutral-100;
}
</style>
